import React from "react"
import PropTypes from "prop-types"

import BlobWide from "../../../../../images/Blob-wide.svg"

export const Answer = ({
  guidance,
  id,
  illustration,
  name,
  nextFunc,
  questionValue,
  setDesktopGuidanceVisible,
  value,
}) => {
  const [guidanceMobileVisible, setGuidanceMobileVisibility] = React.useState(
    false
  )
  const AnswerGuidanceElement = React.useRef(null)

  const toggleAnswerGuidanceMobile = () => {
    const AnswerGuidance = AnswerGuidanceElement.current
    const AnswerGuidanceHeight = AnswerGuidance.scrollHeight

    if (AnswerGuidance.style.maxHeight) {
      AnswerGuidance.style.maxHeight = null
      setGuidanceMobileVisibility(false)
    } else {
      AnswerGuidance.style.maxHeight = AnswerGuidanceHeight + "px"
      setGuidanceMobileVisibility(true)
    }
  }

  return (
    <div className="boiler-quote-answer">
      <button
        className="boiler-quote-answer-header"
        onClick={() => nextFunc(questionValue, value)}
        onMouseOver={() => setDesktopGuidanceVisible(id)}
        onMouseOut={() => setDesktopGuidanceVisible("")}
      >
        <div className="boiler-quote-answer-graphic">
          <BlobWide />
          <img src={illustration} alt={name} />
        </div>
        <h2 className="boiler-quote-answer-name">{name}</h2>
      </button>
      <button
        className={`boiler-quote-answer-guidance-button-mobile${
          guidanceMobileVisible ? " active" : ""
        }`}
        onClick={() => toggleAnswerGuidanceMobile()}
      >
        <span className="question-mark">?</span>
        <span className="icon-minus"></span>
      </button>
      <div
        ref={AnswerGuidanceElement}
        className={`boiler-quote-answer-guidance-mobile${
          guidanceMobileVisible ? " active" : ""
        }`}
      >
        <p>{guidance}</p>
      </div>
      <span className="boiler-quote-answer-guidance-queue">?</span>
    </div>
  )
}

Answer.propTypes = {
  guidance: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  illustration: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  nextFunc: PropTypes.func.isRequired,
  questionValue: PropTypes.string.isRequired,
  setDesktopGuidanceVisible: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
}
